import React, { Component, Fragment } from 'react';
import Input from '../../../components/UI/Input/Input';
import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './CheckoutForm.css';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../../../store/actions/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../../axios-orders';
import { updateObject } from '../../../shared/utilities';

class CheckoutForm extends Component {

  state = {
    orderForm: {
      firstName: {
        label: 'First Name',
        elementType: 'input',
        size: 'half',
        touched: false,
        validation: {
          required: true
        },
        valid: false,
        config: {
          type: 'text',
          name: 'firstName',
          id: 'firstName',
          maxLength: '30',
          value: ''
        }
      },
      lastName: {
        label: 'Last Name',
        elementType: 'input',
        size: 'half',
        touched: false,
        validation: {
          required: true
        },
        valid: false,
        config: {
          type: 'text',
          name: 'lastName',
          id: 'lastName',
          maxLength: '30',
          value: ''
        }
      },
      email: {
        label: 'Email',
        elementType: 'input',
        size: 'half',
        touched: false,
        validation: {
          required: true,
          emailFormat: true
        },
        valid: false,
        config: {
          type: 'email',
          name: 'email',
          id: 'email',
          maxLength: '30',
          value: ''
        }
      },
      phone: {
        label: 'Phone',
        elementType: 'input',
        size: 'half',
        touched: false,
        validation: {
          required: true
        },
        valid: false,
        config: {
          type: 'tel',
          name: 'phone',
          id: 'phone',
          maxLength: '20',
          value: ''
        }
      },
      city: {
        label: 'City',
        elementType: 'input',
        size: 'half',
        touched: false,
        validation: {
          required: true
        },
        valid: false,
        config: {
          type: 'text',
          name: 'city',
          id: 'city',
          maxLength: '30',
          value: ''
        }
      },
      state: {
        label: 'State',
        elementType: 'input',
        size: 'half',
        touched: false,
        validation: {
          required: true
        },
        valid: false,
        config: {
          type: 'text',
          name: 'state',
          id: 'state',
          maxLength: '30',
          value: ''
        }
      },
      streetAddress: {
        label: 'Street Address',
        elementType: 'input',
        size: 'threeQuarters',
        touched: false,
        validation: {
          required: true
        },
        valid: false,
        config: {
          type: 'text',
          name: 'streetAddress',
          id: 'streetAddress',
          maxLength: '30',
          value: ''
        }
      },
      zip: {
        label: 'Zip',
        elementType: 'input',
        size: 'quarter',
        touched: false,
        validation: {
          required: true,
          minLength: 5,
          maxLength: 5
        },
        valid: false,
        config: {
          type: 'number',
          name: 'zip',
          id: 'zip',
          maxLength: '5',
          value: ''
        }
      },
      deliveryMethod: {
        label: 'Delivery Method',
        elementType: 'select',
        size: 'half',
        touched: false,
        validation: {
          required: true
        },
        valid: true,
        config: {
          id: 'deliveryMethod',
          options: [
            { value: 'fastest', displayValue: 'Fastest' },
            { value: 'cheapest', displayValue: 'Cheapest' }
          ],
          value: 'fastest'

        }
      },
      instructions: {
        label: 'Special Instructions',
        elementType: 'textarea',
        size: 'whole',
        touched: false,
        validation: {
          required: false
        },
        valid: true,
        config: {
          name: 'instructions',
          id: 'instructions',
          maxLength: '400',
          value: ''
        }
      }
    },
    sendable: false
  }

  componentDidMount() {
    this.props.DisplayFormError(null);
  }

  orderSendingHandler = (event) => {
    event.preventDefault();
    let orderID = this.props.orderID;
    if (orderID === null) {
      orderID = 0;
    }
    const formData = {};
    for (let input in this.state.orderForm) {
      formData[input] = this.state.orderForm[input].config.value;
    }
    const orderData = {
      orderID: orderID,
      orderTime: new Date(),
      price: Math.round(parseFloat(this.props.price) * 1e2) / 1e2,
      ingredients: this.props.ingredients,
      customer: {
        name: {
          firstName: formData.firstName,
          lastName: formData.lastName
        },
        address: {
          city: formData.city,
          state: formData.state,
          streetAddress: formData.streetAddress
        },
        email: formData.email,
        phone: formData.phone
      },
      instructions: formData.instructions,
      deliveryMethod: formData.deliveryMethod
    }
    this.props.submitOrder(orderData);
  }

  checkValidity(value, rules) {
    let isValid = false;
    let invalidChecks = [];
    if (rules.required) {
      if (value.trim() === '') {
        invalidChecks.push('required failed');
      };
    }

    if (rules.minLength) {
      if (value.length < rules.minLength) {
        invalidChecks.push('minLength failed')
      }
    }

    if (rules.maxLength) {
      if (value.length > rules.maxLength) {
        invalidChecks.push('maxLength failed')
      }
    }

    if (rules.emailFormat) {
      let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
      if (!emailRegex.test(value)) {
        invalidChecks.push('emailFormat failed')
      }
    }

    if (invalidChecks.length === 0) {
      isValid = true;
    }
    return isValid;
  }

  validateForm = (orderForm) => {
    let formIsValid = true;

    for (let formItem in orderForm) {
      formIsValid = orderForm[formItem].valid && formIsValid;
    }

    return formIsValid;
  }

  updateCustomerInfo = (key, value) => {
    const updatedOrderForm = updateObject(this.state.orderForm, {
      [key]: updateObject(this.state.orderForm[key], {
        config: updateObject(this.state.orderForm[key].config, { value: value }),
        valid: this.checkValidity(value, this.state.orderForm[key].validation)
      })
    })

    const formComplete = this.validateForm(updatedOrderForm);
    this.setState({ orderForm: updatedOrderForm, sendable: formComplete });
  }

  markTouched = (inputElement) => {
    const updatedOrderForm = updateObject(this.state.orderForm, {
      [inputElement]: updateObject(this.state.orderForm[inputElement], {
        touched: true
      })
    })

    this.setState({ orderForm: updatedOrderForm });
  }

  render() {

    let formItems = [];
    let errorMessage = null;
    if (this.props.errorMessage) {
      errorMessage = <p className={classes.ErrorMessage}>{this.props.errorMessage}</p>
    }
    if (this.state.orderForm) {
      for (let formItem in this.state.orderForm) {
        formItems.push(
          <Input key={this.state.orderForm[formItem].config.id} formGroupSize={this.state.orderForm[formItem].size} label={this.state.orderForm[formItem].label} inputType={this.state.orderForm[formItem].elementType} touched={this.state.orderForm[formItem].touched} valid={this.state.orderForm[formItem].valid} config={this.state.orderForm[formItem].config} update={this.updateCustomerInfo} markTouched={this.markTouched} />
        )
      }
    }

    let form = (
      <form onSubmit={(event) => {
        event.preventDefault();
        if (this.state.sendable) {
          this.orderSendingHandler(event);
        }
      }}
        className={classes.CheckoutForm} >

        <h2 className={classes.CheckoutHeader}>Enter Your Delivery Info</h2>
        {errorMessage}
        <div className={classes.FormWrapper}>
          {formItems}
        </div>

        <div className={classes.CheckoutButtons}>
          <Button type='button' clicked={() => { this.props.history.push('/build') }} style={{ height: '40px', width: '30%', margin: '10px auto', display: 'block' }} btnType={'Danger'}>Cancel</Button>

          <Button type='submit' style={{ width: '40%', margin: '10px auto', display: 'block' }} btnType={this.state.sendable ? 'submit' : "Disabled"}>Submit Order</Button>
        </div>

      </form>
    )

    if (this.props.orderSending === true) {
      form = (
        <form className={classes.CheckoutForm} action="">
          <Spinner />
        </form>
      )
    }

    return (
      <Fragment>
        { form}
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orderSending: state.orders.orderSending,
    errorMessage: state.orders.errorMessage,
    orderID: state.orders.nextOrderID,
    ingredients: state.burger.ingredients,
    price: state.burger.totalPrice
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    DisplayFormError: (error) => dispatch(actionCreators.displayFormError(error))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withErrorHandler(CheckoutForm, axios)));


// WEBPACK FOOTER //
// ./src/containers/Checkout/CheckoutForm/CheckoutForm.jsx